'use client';

import { c as _c } from "react/compiler-runtime";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { ConversionTimelineChartProps } from '../../types/lote.types';
const CHART_COLORS = {
  success: 'rgb(22, 163, 74)',
  error: 'rgb(220, 38, 38)'
};
export function ConversionTimelineChart(t0) {
  const $ = _c(13);
  const {
    data
  } = t0;
  const hasData = data.some(_temp);
  if (!hasData) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-full items-center justify-center"><p className="text-body font-body text-subtext-color">Sem dados de conversão ainda</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      top: 5,
      right: 10,
      left: -10,
      bottom: 0
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <linearGradient id="colorAcordos" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={CHART_COLORS.success} stopOpacity={0.3} /><stop offset="95%" stopColor={CHART_COLORS.success} stopOpacity={0} /></linearGradient>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs>{t2}<linearGradient id="colorSemAcordo" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={CHART_COLORS.error} stopOpacity={0.3} /><stop offset="95%" stopColor={CHART_COLORS.error} stopOpacity={0} /></linearGradient></defs>;
    t4 = <CartesianGrid strokeDasharray="3 3" stroke="rgb(229, 229, 229)" />;
    t5 = <XAxis dataKey="date" fontSize={11} stroke="rgb(115, 115, 115)" tickLine={false} interval="preserveStartEnd" />;
    t6 = <YAxis fontSize={11} stroke="rgb(115, 115, 115)" tickLine={false} allowDecimals={false} />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Tooltip contentStyle={{
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(229, 229, 229)",
      borderRadius: "8px",
      fontSize: "13px"
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Legend wrapperStyle={{
      fontSize: "12px",
      paddingTop: "8px"
    }} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Area type="monotone" dataKey="acordos" stroke={CHART_COLORS.success} strokeWidth={2} fill="url(#colorAcordos)" name="Acordos Fechados" dot={false} activeDot={{
      r: 4,
      fill: CHART_COLORS.success
    }} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Area type="monotone" dataKey="semAcordo" stroke={CHART_COLORS.error} strokeWidth={2} fill="url(#colorSemAcordo)" name="Sem Acordo" dot={false} activeDot={{
      r: 4,
      fill: CHART_COLORS.error
    }} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== data) {
    t11 = <ResponsiveContainer width="100%" height="100%"><AreaChart data={data} margin={t1}>{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</AreaChart></ResponsiveContainer>;
    $[11] = data;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
}
function _temp(d) {
  return d.acordos > 0 || d.semAcordo > 0;
}